var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatewayNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2048,
    width: 2048,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.67810833 1041.7437c-.2963131.2963-.29493424.7989.001379 1.0952l8.78496731 8.7849c.2963131.2964.7988755.2977 1.0951885 0l8.786353-8.7863c.296313-.2963.294934-.7989-.0014-1.0952l-8.784967-8.785c-.296313-.2963-.7988753-.2977-1.0951884 0l-8.78635327 8.7864zm1.07861357.5483 8.2546441-8.2547 8.254638 8.2547-8.254645 8.2546-8.2546371-8.2546z",
    transform: "matrix(96.752895 0 0 96.752895 55.328158 -99820.70216999998)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayNone);
export default __webpack_public_path__ + "static/media/gateway-none.9c7b5e712cfd2fa7e6d12b01b79505c4.svg";
export { ForwardRef as ReactComponent };